import { z } from '../zod.js';
import { CALENDAR_ERROR_CODES, CALENDAR_WARNING_CODES, FOUNDRY_IMPORT_WARNING_CODES, PARSE_ERROR_CODES, WHEN_KINDS, WHEN_PREVIEW_STATUSES, } from './rows-calendar.js';
/**
 * The calendar vocabularies (1.0b deliverable 3), so that the engine and the exit-1b DTOs read one
 * list each. The values live in `rows-calendar.ts`.
 */
export { CALENDAR_ERROR_CODES, CALENDAR_WARNING_CODES, FOUNDRY_IMPORT_WARNING_CODES, PARSE_ERROR_CODES, WHEN_KINDS, WHEN_PREVIEW_STATUSES, };
export const CalendarErrorCode = z.enum(CALENDAR_ERROR_CODES);
export const CalendarWarningCode = z.enum(CALENDAR_WARNING_CODES);
export const FoundryImportWarningCode = z.enum(FOUNDRY_IMPORT_WARNING_CODES);
export const ParseErrorCode = z.enum(PARSE_ERROR_CODES);
export const WhenKind = z.enum(WHEN_KINDS);
export const WhenPreviewStatus = z.enum(WHEN_PREVIEW_STATUSES);
/**
 * A JSON pointer (RFC 6901): the empty string for the whole document, otherwise `/`-separated
 * reference tokens with `~` written `~0` and `/` written `~1`.
 */
export const JsonPointer = z.string().regex(/^(\/([^~/]|~[01])*)*$/);
/**
 * One finding of the calendar engine's `compile`: an error with a {@link CalendarErrorCode} or a
 * warning with a {@link CalendarWarningCode}, at a JSON pointer into the definition. It names a
 * place, never copies the calendar's text. `calendar_invalid` (422) carries a list of these as
 * `details.issues`.
 */
export const CalendarIssue = z.discriminatedUnion('severity', [
    z.strictObject({ code: CalendarErrorCode, severity: z.literal('error'), path: JsonPointer }),
    z.strictObject({ code: CalendarWarningCode, severity: z.literal('warning'), path: JsonPointer }),
]);
/**
 * An import warning of `importFoundry`, kept as P0-13 built it: `path` (a pointer into the file,
 * set only for `invalid_calendar`) and `seasonIndex` (the 0-based index of a season as declared,
 * set for the season-bounds codes) are optional rather than null, an exception to the response
 * rule, so the import stays unchanged. It replaces the name `ImportWarning`.
 */
export const FoundryImportWarning = z.strictObject({
    code: FoundryImportWarningCode,
    severity: z.enum(['warning', 'error']),
    path: z.string().optional(),
    seasonIndex: z.number().int().min(0).optional(),
});
//# sourceMappingURL=vocabularies.js.map